import { render, staticRenderFns } from "./CartTableProducts.vue?vue&type=template&id=b6bec8ca&scoped=true&"
import script from "./CartTableProducts.vue?vue&type=script&lang=js&"
export * from "./CartTableProducts.vue?vue&type=script&lang=js&"
import style0 from "./CartTableProducts.vue?vue&type=style&index=0&id=b6bec8ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bec8ca",
  null
  
)

export default component.exports